export const tr = {
    'status-new': 'Yeni',
    'status-no': 'Reddedildi',
    'status-waiting': 'Onay bekleniyor',
    'status-yes': 'Kabul edildi'
};
